export default {
  black: '24, 24, 27',
  gray: '82, 82, 91',
  brown: '101, 67, 33',
  maroon: '91, 6, 22',
  red: '239, 68, 68',
  orange: '249, 115, 22',
  amber: '245, 158, 11',
  yellow: '234, 178, 8',
  olive: '80, 100, 44',
  lime: '131, 204, 22',
  green: '34, 197, 94',
  emerald: '16, 185, 129',
  teal: '20, 184, 165',
  cyan: '6, 181, 212',
  sky: '14, 165, 233',
  blue: '59, 131, 246',
  navy: '34, 53, 140',
  indigo: '99, 101, 241',
  violet: '138, 92, 246',
  purple: '169, 85, 247',
  fuchsia: '216, 70, 239',
  pink: '236, 72, 154',
  rose: '244, 63, 93',
  coral: '239, 97, 90'
}